const sanitizeName = (value) => {
  if (!value) return '';
  const trimmed = String(value).trim();
  if (!trimmed) return '';
  const withoutLeadingJunk = trimmed.replace(/^[^\p{L}\p{N}]+/u, '');
  return withoutLeadingJunk.replace(/\s+/g, ' ').trim();
};

export const extractFirstName = (fullName) => {
  const cleaned = sanitizeName(fullName);
  if (!cleaned) return '';
  return cleaned.split(/\s+/)[0];
};
